// extracted by mini-css-extract-plugin
export default {"container":"ProductModal_container__5CtC2","selectionRow":"ProductModal_selectionRow__Ckd1E"};